import React from 'react';
import './ValuesView.css';

export default function ValuesView() {
  return (
    <section className="values-view landing__section" aria-labelledby="values-heading">
      <div className="landing__column">
        <div className="fade-up">
          <p className="values-view__label">What this looks like</p>
          <h2 className="values-view__heading" id="values-heading">
            Your values, in your words.
          </h2>
          <p className="values-view__lede">
            Not a list you downloaded. Not a template. You write the description —
            the app remembers it and ties your goals back to it.
          </p>

          <div className="values-view__cards" aria-label="Example values cards">
            <div className="values-view__card">
              <div className="values-view__card-name">Presence</div>
              <p className="values-view__card-desc">
                Being fully in the room. Not distracted, not elsewhere.
                The people in front of me deserve my full attention.
              </p>
              <div className="values-view__card-footer">
                <span className="values-view__card-tag">4 goals</span>
              </div>
            </div>

            <div className="values-view__card">
              <div className="values-view__card-name">Craft</div>
              <p className="values-view__card-desc">
                Doing the work properly, even when no one is watching.
                The standard I hold myself to when I'm alone.
              </p>
              <div className="values-view__card-footer">
                <span className="values-view__card-tag">3 goals</span>
              </div>
            </div>

            <div className="values-view__card">
              <div className="values-view__card-name">Health</div>
              <p className="values-view__card-desc">
                The foundation everything else stands on. Worth protecting
                even when it's inconvenient.
              </p>
              <div className="values-view__card-footer">
                <span className="values-view__card-tag">2 goals</span>
              </div>
            </div>
          </div>

          <p className="values-view__caption">
            Aspirational view — design in progress.
          </p>
        </div>
      </div>
    </section>
  );
}
